import React, { useRef, useEffect } from 'react';
import { CrescentStar, ZelligeCorner, ZelligeBg, Divider, AID } from './AidOrnaments';
import { FloatingLantern, GoldParticles, TwinkleStars } from './AidAnimations';

const shimmerBg = `linear-gradient(90deg, ${AID.goldDeep}, ${AID.goldLight}, ${AID.gold}, ${AID.goldDeep})`;

function AidLoginOverlay() {
  const titleRef = useRef(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const anim = el.animate(
      [{ backgroundPosition: '0% 50%' }, { backgroundPosition: '200% 50%' }],
      { duration: 6000, iterations: Infinity, easing: 'linear' }
    );
    return () => anim.cancel();
  }, []);

  return (
    <div style={{
      position: 'absolute', inset: 0,
      pointerEvents: 'none',
      overflow: 'hidden',
      zIndex: 0,
    }}>
      {/* Motif zellige en fond */}
      <ZelligeBg color={AID.gold} opacity={0.07} />
      <TwinkleStars count={18} />

      {/* Lanternes suspendues aux 4 coins */}
      <FloatingLantern x={8}  delay={0}   scale={0.90} dur={5.5} swayDeg={5} />
      <FloatingLantern x={20} delay={0.8} scale={0.75} dur={6.5} swayDeg={4} />
      <FloatingLantern x={76} delay={0.4} scale={0.85} dur={5.8} swayDeg={5} />
      <FloatingLantern x={89} delay={1.2} scale={0.70} dur={7.2} swayDeg={4} />

      {/* Emblème centré au-dessus de la carte login */}
      <div style={{
        position: 'absolute',
        top: '12%',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10,
        zIndex: 1,
        whiteSpace: 'nowrap',
      }}>
        <CrescentStar size={64} color={AID.goldDeep} glow />

        {/* Calligraphie arabe avec shimmer doré */}
        <div ref={titleRef} dir="rtl" style={{
          fontFamily: "'Amiri', 'Georgia', serif",
          fontSize: 40,
          fontWeight: 700,
          background: shimmerBg,
          backgroundSize: '200% 100%',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          lineHeight: 1,
          userSelect: 'none',
        }}>
          عيد الأضحى مبارك
        </div>

        <Divider color={AID.gold} width={280} />

        <div style={{
          fontFamily: "'Reem Kufi', 'Arial', sans-serif",
          letterSpacing: 6,
          fontSize: 13,
          color: AID.brown,
          fontWeight: 700,
          userSelect: 'none',
        }}>
          AID MOUBARAK SAÏD
        </div>
      </div>

      {/* Particules dorées tombantes */}
      <GoldParticles count={20} />

      {/* Coins zellige décoratifs */}
      <div style={{ position: 'absolute', top: 0, left: 0 }}>
        <ZelligeCorner size={190} color={AID.gold} opacity={0.20} flip="tl" />
      </div>
      <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
        <ZelligeCorner size={190} color={AID.gold} opacity={0.20} flip="br" />
      </div>

      {/* Ruban doré en bas */}
      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0,
        height: 5,
        background: `linear-gradient(90deg, transparent, ${AID.gold}, ${AID.goldLight}, ${AID.gold}, transparent)`,
      }} />
    </div>
  );
}

export default AidLoginOverlay;
